import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import style from './CatalogPreviewModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import {useTranslation} from 'react-i18next';
import AppConfigService from '../../service/AppConfigService';

const CatalogPartnerModal = (props) => {

  let env = AppConfigService.getEnvironment();

  let {
    documentId,
    show = false,
    onCloseHandler
  } = props;

  const [height, setHeight] = useState(610);

  const {t} = useTranslation(['catalog']);

  const onIframeLoad = () => {
    //find the height of the internal page
    // var the_height = document.getElementById('iframe').contentWindow.document.body.scrollHeight;

    
      //change the height of the iframe
    // document.getElementById('iframe').height = the_height;
        
    // console.log('This iframe should be ' + the_height + ' pixels in height to avoid scrolling.');
  }

  useEffect(() => {
    window.addEventListener("message", onMessage, false);
  }, []);

  useEffect(() => {
    // console.log("Found height: ", height);
  }, [height]);

  const onMessage = (event) => {
    if (event) {
      if (event.origin.includes('//cloud.')) {
        // console.log("event.data:", event.data);
        try {
          let eventData = event.data;
          if (eventData.event === "loadedContentHeight") {
            setHeight(eventData.height);
          }
        } catch (e) {
          console.log("error parsing onMessage: ", e);
        };
      }
    }
  }

  return (
    <Modal
      show={show}
      onHide={onCloseHandler}
      className="modal-catalog-preview fade"
      dialogClassName={style.CatalogPreviewModal}
      size={'lg'}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t('catalog.partner.modalTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <iframe id="partner-iframe" src={AppConfigService.getCloudPartnerHost(env)+"/apply/new/"+documentId} frameBorder="0" width="100%" height={height} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onCloseHandler} className="btn btn-default btn-wide btn-xl" data-dismiss="modal" aria-label="Close">{t('close')}</button>
      </Modal.Footer>
    </Modal>
  )

};

export default CatalogPartnerModal;
